export const fileTypes = [
    "video/3g2",
    "video/3gp",
    "video/aaf",
    "video/asf",
    "video/avchd",
    "video/avi",
    "video/drc",
    "video/flv",
    "video/m2v",
    "video/m3u8",
    "video/m4p",
    "video/m4v",
    "video/mkv",
    "video/mng",
    "video/mov",
    "video/mp2",
    "video/mp4",
    "video/mpe",
    "video/mpeg",
    "video/mpg",
    "video/mpv",
    "video/mxf",
    "video/nsv",
    "video/ogg",
    "video/ogv",
    "video/qt",
    "video/rm",
    "video/rmvb",
    "video/roq",
    "video/svi",
    "video/vob",
    "video/webm",
    "video/wmv",
    "video/yuv",
];
